import { Injectable } from "@angular/core";
import { Utils } from "../utils";

declare var ga: Function;

@Injectable( {
    providedIn: "root"
} )
export class GoogleAnalyticsService {
    private _ga = function () {
        if ( ( <any> window ).ga && ga ) ga.apply( ga, arguments );
    };

    get ga (): Function {
        return this._ga;
    }

    sendPageView (
        page: string
    ) {
        if ( typeof ga === 'undefined' ) return;
        if ( !page.startsWith( '/' ) ) page = `/${ page }`;
        ga( 'send', 'pageview', page );
    }

    sendComponentView (
        componentName: string
    ) {
        if ( typeof ga === 'undefined' ) return;
        ga( 'send', 'componentView', componentName );
    }

    constructor () { }
}
